import Vue from "vue";
import firebase from "firebase";
import store from "./store";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Register from "./views/Register.vue";
import Dashboard from "./views/Dashboard.vue";
import Inventory from "./views/Inventory.vue";
import Orders from "./views/Orders.vue";
import Order from "./views/Order.vue";
import OrderDetails from "./views/OrderDetails.vue";
import Clients from "./views/Clients.vue";
import Client from "./views/Client.vue";
import PriceList from "./views/PriceList.vue";
import Profile from "./views/Profile.vue";
import Assets from "./views/Assets.vue";
import PurchaseOrders from "./views/PurchaseOrders.vue";
import PurchaseOrder from "./views/PurchaseOrder.vue";
import ForgotPassword from "./views/ForgotPassword.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/forgot-password",
      name: "Forgot Password",
      component: ForgotPassword,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/inventory",
      name: "Inventory",
      component: Inventory,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/orders",
      name: "Orders",
      component: Orders,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/order/:id",
      name: "Order",
      component: Order,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/orderdetails/:id",
      name: "Order Deatils",
      component: OrderDetails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/clients",
      name: "Clients",
      component: Clients,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/client/:id",
      name: "Client",
      component: Client,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/pricelist",
      name: "PriceList",
      component: PriceList,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/assets",
      name: "Assets",
      component: Assets,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/purchaseOrders",
      name: "Purchase Orders",
      component: PurchaseOrders,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/purchaseOrder/:id",
      name: "Purchase Order",
      component: PurchaseOrder,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next("/");
  } else {
    next();
  }
});

export default router;
